import { ReactNode } from 'react';

import { TDayTripEvent } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/types';

import { IDatesRange, IDaysRange, IRooming } from '../../../../../../structure';

export enum EEventType {
  All = 'all',
  Flight = 'flight',
  Accommodation = 'accommodation',
}

export interface ITravelBrief {
  accommodations: ITravelBriefAccommodationDay[];
  flights: ITravelBriefDay<TDate>[];
  overall: ITravelBriefDay<TDateRange>[];
}

export interface ITravelBriefDay<T> extends TDates<T> {
  activities: TDayTripEvent[];
}

export type TDates<T> = {
  dates: T;
};

export interface ITravelBriefAccommodationDay extends TDates<TDateRange> {
  accommodation: ITravelBriefAccommodation;
  nights: TNightsCount;
  rooms: IRooms;
}

export interface IRooms {
  rooming: IRooming[];
  roomBasis: string;
}

export interface ITravelBriefAccommodation {
  id: number;
  name: string;
  isAlternate: boolean;
  nights: TNightsCount;
}

export type TNightsCount = number;

export interface IEventType {
  name: string;
  label: string;
  icon: ReactNode;
}

export type TDate = { day: number; date: string | null };

export type TDateRange = {
  datesRange: IDatesRange;
  daysRange: IDaysRange;
};

export type WithValue<T> = {
  value: T;
};

export type CellProps<T> = WithValue<T> & {
  row?: {
    original?: {
      accommodation?: ITravelBriefAccommodation;
    };
  };
};
